export default function selectAll (els, context) {
  return Array.prototype.slice.call((context || document).querySelectorAll(els));
}



/** WEBPACK FOOTER **
 ** ./selectAll.js
 **/